module.exports = __webpack_public_path__ + "img/cloud1.c1599773.png";